export var ShirtSizes;
(function (ShirtSizes) {
    ShirtSizes["XS"] = "XS";
    ShirtSizes["S"] = "S";
    ShirtSizes["M"] = "M";
    ShirtSizes["L"] = "L";
    ShirtSizes["XL"] = "XL";
    ShirtSizes["XXL"] = "XXL";
})(ShirtSizes || (ShirtSizes = {}));
